import React from 'react';
import PropTypes from 'prop-types';

import '../css/toggleButtons.css';

import { isString } from '../util/string';

const FormatButton = (valueObject, activeValue, onSelect) => {
    let label = valueObject;
    let value = valueObject;
    if (!isString(valueObject)) {
        label = valueObject.label;
        value = valueObject.value;
    }
    return (<button key={value} className={`btn btn-default toggle-button${value === activeValue ? ' active' : ''}`} onClick={() => onSelect(value)} >{label}</button>);
};

const ToggleButtons = ({ onSelect, className, value, style, options }) => (
    <div className={`btn-group color-attribute toggle-buttons ${className}`} style={style}>
        {options.map(option => FormatButton(option, value, onSelect))}
    </div>
);

ToggleButtons.propTypes = {
    onSelect: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            value: PropTypes.any,
            label: PropTypes.string,
        }),
    ])),
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default ToggleButtons;



// WEBPACK FOOTER //
// ./src/components/ToggleButtons.jsx